import { getModule } from "vuex-module-decorators";
import TimeSchedulerModule from "@/stores/modules/time-scheduler";
import { TimeOption } from "@/utils/types";
import TimeSlot, { TimeSlotState } from "@/models/time-slot";

export function applyNewTimeSlots(timeSchedulerModule: TimeSchedulerModule) {
    return async () => {
        await timeSchedulerModule.fetchTimeSlots();
        timeSchedulerModule.setCurrentTimeSlot();
        if (timeSchedulerModule.selectedTimeOption === TimeOption.LATER) {
            const selectedSlot = timeSchedulerModule.selectedTimeSlot;
            if (selectedSlot && selectedSlot.state !== TimeSlotState.AVAILABLE) {
                let index = timeSchedulerModule.timeSlots.findIndex((timeSlot: TimeSlot) => timeSlot.start().getTime() === selectedSlot.start().getTime());
                if (index !== -1) {
                    for (++index; index < timeSchedulerModule.timeSlots.length; index++) {
                        if (timeSchedulerModule.timeSlots[index].state === TimeSlotState.AVAILABLE) {
                            return timeSchedulerModule.setSelectedTimeSlot(timeSchedulerModule.timeSlots[index]);
                        }
                    }
                }
                return timeSchedulerModule.setSelectedTimeSlot(null);
            }
        }
    }
}

export default function updateCurrentTimeSlot() {
    return (store: any) => {
        const timeSchedulerModule = getModule(TimeSchedulerModule, store);

        setInterval(applyNewTimeSlots(timeSchedulerModule), 20 * 1000);
    };
}
